import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/empty-image-upload.png'


const _hoisted_1 = { class: "p-4 flex items-center justify-between border-bottom-grey-3 mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-xl" }, "Edit Transaksi Refund", -1)
const _hoisted_3 = { class: "content mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "italic text-base text-grey mb-4" }, "Edit liter atau nominal kemudian jelaskan alasan mengapa transaksi pengisian BBM ini refund!", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-base required" }, "Liter", -1)
const _hoisted_7 = { class: "md:grid grid-cols-2 gap-4" }
const _hoisted_8 = { class: "p-inputgroup flex-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Liter", -1)
const _hoisted_10 = { class: "p-inputgroup flex-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Liter", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "invalid-feedback" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-base required" }, "Nominal", -1)
const _hoisted_16 = { class: "md:grid grid-cols-2 gap-4" }
const _hoisted_17 = { class: "p-inputgroup flex-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp", -1)
const _hoisted_19 = { class: "p-inputgroup flex-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp", -1)
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { class: "invalid-feedback" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-base required" }, "Alasan", -1)
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-base required" }, "Upload Gambar", -1)
const _hoisted_28 = { class: "border-grey-3 rounded-lg p-3" }
const _hoisted_29 = { class: "flex-col gap-4 justify-center items-center" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = {
  key: 0,
  class: ""
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "m-auto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "mx-auto"
  })
], -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-grey font-base text-center" }, "Ukuran gambar maksimal 1 MB format JPG atau PNG", -1)
const _hoisted_37 = { class: "flex justify-center gap-4 items-center mt-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-camera text-sm" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times color-danger text-sm" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "color-danger font-extrabold" }, "Hapus", -1)
const _hoisted_41 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_42 = { class: "flex items-center justify-end gap-4" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Simpan")

import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import { ref, toRefs, watch, onMounted, getCurrentInstance } from 'vue'
import * as Yup from 'yup'
import { Field, useForm } from 'vee-validate'
import InputNumber from 'primevue/inputnumber'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import apiImageUseCase from '@/usecase/apiImageUseCase'
import { useStore } from 'vuex'
import environment from '@/configs/environtment'
import rgxExp from '@/utils/helpers/regExp'
import apiUseCase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'FinanceRefundForm',
  props: {
  isShow: {
    default: false
  },
  data: {
    default: null
  }
},
  emits: ["close", "submit"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'submit', notes: any, data: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const fuelPartnerEndpoint = '/management/v2/FuelStationPartners'
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const store = useStore()
const tempImgEvidence = ref<any | null>(null)
const maxSizeFile = 1024 * 1024 * 1
const { isShow, data } = toRefs(props)
const dataParent = ref(null) as any
const showModal = ref(false)
const fuelBasePrice = ref(0)
const initialValues = ref({
  newPrice: 0,
  newLiters: 0,
  note: null as any,
  evidenceImg: null as any
})

const schema = Yup.object().shape({
  note: Yup.string()
    .required('Alasan harus diisi!')
    .matches(rgxExp.notPrefixSpace, 'Keterangan tidak boleh hanya menggunakan spasi.')
    .min(10, 'Keterangan minimal 10 karakter')
    .max(255, 'Keterangan maksimal 255 karakter'),
  evidenceImg: Yup.object().required('Data wajib diisi'),
  newLiters: Yup.number()
    .typeError('Liter harus diisi!')
    .required('Liter harus diisi!')
    .min(0, 'Liter baru minimal 0')
    .test('maxDigits', 'Liter baru tidak valid', (value) => {
      const valConfert = value?.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      return numberRegex.test(valConfert)
    }),
  newPrice: Yup.number()
    .typeError('Harga harus diisi!')
    .required('Harga harus diisi!')
    .min(0, 'Harga baru minimal 0'),
})
// eslint-disable-next-line prefer-arrow-callback
// }).test('price-diff', 'Harga baru tidak boleh lebih besar dari Harga lama', function (this: Yup.TestContext, values) {
//   // console.log('hehe', values)
//   if (!values) return true
//   const { newPrice } = values
//   if (
//     newPrice == null || dataParent.value?.Price == null
//   ) {
//     return true
//   }

//   // return NonConductorCommision + ConductorCommision <= PriceAfterDiscount
//   if (newPrice > dataParent.value.Price) {
//     return this?.createError({
//       path: 'priceDiff', // <- tampil di field ini
//       message: 'Harga Baru tidak boleh lebih besar dari Harga Lama'
//     })
//   }
//   return true
// }).test('liters-diff', 'Liter baru tidak boleh lebih besar dari Liter lama', function (this: Yup.TestContext, values) {
//   // console.log('hehe', values)
//   if (!values) return true
//   const { newLiters } = values
//   if (
//     newLiters == null || dataParent.value?.Liters == null
//   ) {
//     return true
//   }

//   // return NonConductorCommision + ConductorCommision <= LitersAfterDiscount
//   if (newLiters > dataParent.value.Liters) {
//     return this?.createError({
//       path: 'litersDiff', // <- tampil di field ini
//       message: 'Liter Baru tidak boleh lebih besar dari Liter Lama'
//     })
//   }
//   return true
// })
const { values, errors, setFieldValue, handleSubmit, resetForm, meta } = useForm({
  initialValues,
  validationSchema: schema
})

const closeDialog = () => {
  showModal.value = false
  dataParent.value = null
  resetForm({
    values: {
      newPrice: 0,
      newLiters: 0,
      note: null,
      evidenceImg: null
    }
  })

  tempImgEvidence.value = null
  emit('close')
}

const processUpload: string | null | any = async (file: any) => {
  const payload = new FormData()
  payload.append('file', file)
  // const response = await apiUseCase.postOrPut('media/Upload', null, payload)
  const response = await apiImageUseCase.postOrPut('api/v1/assets', null, payload)
  if (!response.error) {
    return response.result.path
  }
  return null
}

const onSubmit = handleSubmit(async (dataForm: any) => {
  // console.log('hehe')
  store.dispatch('showLoading')
  try {
    let thumbnailTemp = null
    if (dataForm.evidenceImg && typeof dataForm.evidenceImg === 'object') {
      thumbnailTemp = await processUpload(dataForm.evidenceImg.file)
    }

    const payload = {
      FuelingTransactionId: dataParent.value.Id,
      Status: 'Refund',
      Note: null,
      FuelingTransactionRevision: {
        OldLiters: dataParent.value.Liters ?? 0,
        OldPrice: dataParent.value.Price ?? 0,
        NewLiters: dataForm.newLiters,
        NewPrice: dataForm.newPrice,
        Reason: dataForm.note,
        EvidenceImageUrl: `${environment.getImageBaseurl()}${thumbnailTemp}`
      }
    }
    // console.log('payload', payload)
    // store.dispatch('fuelPaymentBatch/pushVerifiedTransactionList', payload)
    emit('submit', null, payload)
    closeDialog()
    store.dispatch('hideLoading')
  } catch (error) {
    console.log('error', error)
    store.dispatch('hideLoading')
  }
})

const openDetailImg = (fileUrl: string) => {
  window.open(fileUrl, '_blank')
}

const onInputFile = (file: any) => {
  /* eslint-disable */
  if (file) {
    const totalSize: number = Number((file.size / 1024 / 1024).toFixed(1))
    if (totalSize > 1) {
      $toast.add({
        severity: 'error',
        detail: 'Ukuran file lebih dari 1MB.',
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      setFieldValue('evidenceImg', { file: file.file, name: file.name, blob: file.blob })
    }
  }
}

const getFuelPartnerData = () => {
  store.dispatch('showLoading')
  apiUseCase.get(`${fuelPartnerEndpoint}/${dataParent.value?.FuelStationPartnerId}`).then((response) => {
    const { error, result } = response
    console.log('res', result)
    fuelBasePrice.value = result.Stocks.filter((dataStocks: any) => dataStocks.Name === dataParent.value.FuelType)[0].Price
  })
  store.dispatch('hideLoading')
}

watch(values, (val: any) => {
  console.log('newLiters', val)
  console.log('fuelBasePrice', fuelBasePrice.value)
  setFieldValue('newPrice', val.newLiters * fuelBasePrice.value)
})

watch(
  [isShow, data],
  ([newIsShow, newData]) => {
    if (newIsShow && newData) {
      dataParent.value = { ...newData }
      console.log('dataParent', dataParent.value)
      getFuelPartnerData()
      showModal.value = true
    } else {
      showModal.value = false
    }
  },
  {
    immediate: true
  }
)

const initData = () => {
  setFieldValue('newLiters', 0)
  setFieldValue('newPrice', 0)
  setFieldValue('note', null)
  setFieldValue('evidenceImg', null)
}

onMounted(() => {
  // console.log('data', data)
  initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Dialog), {
      showHeader: false,
      visible: showModal.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((showModal).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '75vw' },
      modal: true,
      contentClass: "wrap-content-hjp-confirm-modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("i", {
            class: "pi pi-times cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            onSubmit: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
          }, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(InputNumber), {
                          modelValue: _unref(dataParent).Liters,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dataParent).Liters) = $event)),
                          disabled: true,
                          id: "fuelQty",
                          placeholder: "0",
                          min: 0,
                          locale: "id-ID",
                          step: 0.25,
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          inputId: "refund-amount"
                        }, null, 8, ["modelValue", "step"]),
                        _hoisted_9
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(Field), { name: "newLiters" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_unref(InputNumber), {
                              modelValue: _unref(values).newLiters,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).newLiters) = $event)),
                              disabled: false,
                              class: _normalizeClass(`${_unref(errors).newLiters ? 'input-invalid' : ''}`),
                              id: "fuelQty",
                              placeholder: "0",
                              min: 0,
                              locale: "id-ID",
                              step: 0.25,
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              inputId: "refund-amount"
                            }, null, 8, ["modelValue", "class", "step"]),
                            _hoisted_11
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(errors).newLiters), 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(errors).litersDiff), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_unref(InputNumber), {
                          modelValue: _unref(dataParent).Price,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dataParent).Price) = $event)),
                          disabled: true,
                          id: "fuelQty",
                          placeholder: "0",
                          min: 0,
                          locale: "id-ID",
                          inputId: "refund-amount"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(Field), { name: "newPrice" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createVNode(_unref(InputNumber), {
                              modelValue: _unref(values).newPrice,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(values).newPrice) = $event)),
                              disabled: true,
                              class: _normalizeClass(`${_unref(errors).newPrice ? 'input-invalid' : ''}`),
                              id: "fuelPrice",
                              placeholder: "0",
                              min: 0,
                              locale: "id-ID",
                              inputId: "refund-amount"
                            }, null, 8, ["modelValue", "class"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(errors).newPrice), 1),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(errors).priceDiff), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_unref(Field), {
                    name: "note",
                    as: "textarea",
                    rows: "5",
                    cols: "30",
                    maxlength: 255,
                    placeholder: "Tulis alasan Anda (Contoh: Nota tidak sesuai)",
                    class: "",
                    id: "note"
                  }),
                  (_unref(meta).touched)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(errors).note), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        (!_unref(values).evidenceImg && !tempImgEvidence.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                          : (_unref(values).evidenceImg?.blob)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _unref(values).evidenceImg?.blob,
                                class: "wrap-img cursor-pointer mx-auto",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (openDetailImg(_unref(values).evidenceImg.blob)))
                              }, null, 8, _hoisted_34))
                            : (tempImgEvidence.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 2,
                                  src: tempImgEvidence.value.fileUrl,
                                  class: "wrap-img cursor-pointer mx-auto",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (openDetailImg(tempImgEvidence.value.fileUrl)))
                                }, null, 8, _hoisted_35))
                              : _createCommentVNode("", true)
                      ]),
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(ButtonFileUpload, {
                          inputId: "idPhotoProfile",
                          size: maxSizeFile,
                          onOnInputFile: _cache[7] || (_cache[7] = (newFile, oldFile) => onInputFile(newFile))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), { class: "btn-primary flex gap-x-2" }, {
                              default: _withCtx(() => [
                                _hoisted_38,
                                _createTextVNode(" " + _toDisplayString(!_unref(values).evidenceImg && !tempImgEvidence.value ? 'Upload Gambar' : 'Ganti Gambar'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_unref(values).evidenceImg)
                          ? (_openBlock(), _createBlock(_unref(Button), {
                              key: 0,
                              class: "btn-back gap-x-2 flex",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(setFieldValue)('evidenceImg', null)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_39,
                                _hoisted_40
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (_unref(meta).touched)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(errors).evidenceImg), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_unref(Button), {
                class: "btn-back",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (closeDialog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_43
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                id: "Submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              })
            ])
          ], 32)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})